import React, { Component } from 'react';
import '../assets/googleradio.css';
import { cx } from '@emotion/css';
import * as styles from './newQuestionBox.style';
import { title } from './questionWithTextFeild.style';
import QuizIndicator from './QuizIndicator';
import withQuizPic from './hoc/withQuizPic';
import { InlineMath, BlockMath } from 'react-katex';
import 'katex/dist/katex.min.css';


// Helper component to parse and render mixed text and math
const MathParser = ({ text }) => {
  // console.log("MathParser: Input text:", text);
  if (!text) return null;

  const parts = [];
  let lastIndex = 0;

  // Refined regex to find both inline ($...$) and block ($$...$$) math delimiters
  // Captures the content inside the delimiters
  const regex = /(\$\$(.*?)\$\$|\$(.*?)\$)/g;
  let match;

  while ((match = regex.exec(text)) !== null) {
    // console.log("MathParser: Match found:", match);
    // Add preceding text
    if (match.index > lastIndex) {
      parts.push(<span key={`text-${lastIndex}`}>{text.substring(lastIndex, match.index)}</span>);
    }

    const fullMatch = match[0];
    const blockContent = match[2]; // Content for $$...$$
    const inlineContent = match[3]; // Content for $...$

    const isBlock = blockContent !== undefined; // If blockContent is defined, it's a block math
    const innerMath = isBlock ? blockContent : inlineContent;

    // console.log("MathParser: innerMath:", innerMath, "isBlock:", isBlock);

    try {
      parts.push(<InlineMath key={`math-${match.index}`}>{innerMath}</InlineMath>);
      // console.log("MathParser: Rendered math successfully.");
    } catch (error) {
      console.error("KaTeX rendering error for part:", innerMath, error);
      parts.push(<span key={`error-${match.index}`} style={{ color: 'red' }}>{fullMatch}</span>); // Fallback on error, show original math string
    }

    lastIndex = regex.lastIndex;
  }

  // Add any remaining text
  if (lastIndex < text.length) {
    parts.push(<span key={`text-final-${lastIndex}`}>{text.substring(lastIndex)}</span>);
  }

  // console.log("MathParser: Final parts:", parts);
  return <>{parts}</>;
};


class NewQuestionBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      answer: '',
      quizPic: this.props.getRandomImage(1),
    };
    this.handleRadioChange = this.handleRadioChange.bind(this);
  }

  handleRadioChange(event) {
    // set the new value of checked radion button to state using setState function which is async funtion
    this.setState({
      answer: event.target.value,
    });
  }

  selectedanswer = (answer, id) => {
    this.props.selected(answer, id);
  };

  componentDidMount() {
    this.setState({
      answer: this.props.selectedanswer1,
      quizPic: this.props.getRandomImage(this.props.questionnumber),
    });
  }

  render() {

    console.log("NewQuestionBox: category prop:", this.props.category);
    const isMathematicsCategory = this.props.category === 'Mathematics' || this.props.category === 'MathBowl';
    console.log("NewQuestionBox: isMathematicsCategory:", isMathematicsCategory);

    return (
      <div className={cx(styles.multiChoice)}>
        <div className="leftpanel">
          <h2 className={cx(title)}>
            <span>Q{this.props.questionnumber}/</span>
            {this.props.questionCount}
          </h2>
          <img className="quiz-img" src={this.state.quizPic} alt="" />
     
          {this.props.questionCount < 50 ? (
            
            <QuizIndicator
               className="mb-0"
               questionCount={this.props.questionCount}
               questionnumber={this.props.questionnumber}
             /> ):""}
          <div className="s-title">
            {/* Render question using MathParser */}
            {isMathematicsCategory ? (
              <MathParser text={this.props.question} />
            ) : (
              this.props.question
            )}
          </div>
   
      
        </div>
       
        <div className="rightpanel">
          <p className="s-title">Select Answer Below </p>
          {this.props.answer.map((text, index) => (
            <label className={cx(styles.input)} key={index}>
              <div id={this.props.id + index}>
                <input
                  type="radio"
                  key={this.props.id + index}
                  value={text}
                  name={this.props.id}
                  checked={this.state.answer === text}
                  className="radiobutton"
                  onChange={this.handleRadioChange}
                  onClick={() => {
                    this.props.selected(text, this.props.id);
                  }}
                />

                {this.props.category === 'Flags' ? (
                  <div className="flags">{' ' + text}</div>
                ) : (
                  <div className="">
                    {/* Render answer using MathParser */}
                    {isMathematicsCategory ? (
                      <MathParser text={text} />
                    ) : (
                      text
                    )}
                  </div>
                )}
              </div>
            </label>
          ))}
          <div className="btn-group">
            
            {this.props.controlButtons}</div>
        </div>

      </div>
    );
  }
}

export default withQuizPic(NewQuestionBox);
